import { render, staticRenderFns } from "./DefaultField.vue?vue&type=template&id=ae01c4d6&scoped=true"
import script from "./DefaultField.vue?vue&type=script&lang=js"
export * from "./DefaultField.vue?vue&type=script&lang=js"
import style0 from "./DefaultField.vue?vue&type=style&index=0&id=ae01c4d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae01c4d6",
  null
  
)

export default component.exports